import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import BrButton from '@components/BrButton';
import BrIcons from '@components/BrIcons';
import ColorStyles from '@components/ColorStyles';
import { DomUtils } from '@components/UtilComponents/UtilFunctions';

export default class App extends PureComponent {
  static propTypes = {
    columnMap: PropTypes.object.isRequired,
    displayColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
    defaultColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
    columnOptions: PropTypes.object.isRequired,
    onUpdateDisplayColumns: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {
      selectedColumns: [...props.displayColumns],
      isDropdownDisplayed: false,
    }; // may use initial props
  }

  handleToggleDropdown = () => this.setState({ isDropdownDisplayed: !this.state.isDropdownDisplayed });
  handleResetColumn = () => this.setState({ selectedColumns: this.props.defaultColumns });
  handleCancelColumn = () => this.setState({ selectedColumns: this.props.displayColumns, isDropdownDisplayed: false });
  handleSaveColumn = () => {
    this.props.onUpdateDisplayColumns(this.state.selectedColumns);
    this.setState({ isDropdownDisplayed: false });
  };

  handleClickOption = (e) => {
    const { selectedColumns } = this.state;
    const optionValue = e.target.attributes.value;
    const columnKey = optionValue && optionValue.value;
    if (columnKey) {
      const idx = selectedColumns.indexOf(columnKey);
      if (idx >= 0) {
        this.setState({ selectedColumns: [...selectedColumns.slice(0, idx), ...selectedColumns.slice(idx + 1)] });
      } else {
        this.setState({ selectedColumns: [...selectedColumns, columnKey] });
      }
    }
  };

  render() {
    const { columnMap, columnOptions } = this.props;
    const { isDropdownDisplayed, selectedColumns } = this.state;

    const handleBlur = DomUtils.genBlurHandler('column-selector-dropdown', this.handleCancelColumn);
    return (
      <div className="br-table-column-selector" tabIndex="1" onBlur={handleBlur}>
        <BrButton
          title={(
            <div>
              Columns
              <BrIcons.DownCaret isSubComp />
            </div>
          )}
          onClick={this.handleToggleDropdown}
        />
        {!isDropdownDisplayed ? null : (
          <div className="column-selector-dropdown">
            <ul onMouseDown={this.handleClickOption} role="presentation">
              {Object.entries(columnOptions).map(([key, optionGroup]) => (
                <li key={key}>
                  {key}
                  <ul>
                    {optionGroup.map((columnKey) => (
                      <li key={columnKey} value={columnKey}>
                        <label value={columnKey}>
                          <input
                            data-id={`brtable-column-display-option-${columnKey}`}
                            tabIndex="0"
                            type="checkbox"
                            value={columnKey}
                            readOnly
                            checked={selectedColumns.includes(columnKey)}
                          />
                          {columnMap[columnKey].displayName}
                        </label>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
            <div className="flexrow">
              <BrButton
                className="column-selector-conf-btns"
                title="Apply"
                onClick={this.handleSaveColumn}
                colorStyle={ColorStyles.BGBLUE}
              />
              <BrButton
                className="column-selector-conf-btns"
                title="Cancel"
                onClick={this.handleCancelColumn}
                colorStyle={ColorStyles.BGRED}
              />
              <BrButton
                className="column-selector-conf-btns"
                title="Reset"
                onClick={this.handleResetColumn}
                colorStyle={ColorStyles.BGGRAY}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
